import { MDBTypography } from 'mdb-react-ui-kit';
import React from 'react';

const PivotTableTitle = ({ title }) => {
  return <MDBTypography variant="h5">{title}</MDBTypography>;
};

export default PivotTableTitle;
